import deepmerge from 'deepmerge';
import beam from './beam';

const makeEvent =
  <TData, TEvents>(data: TData) =>
  <T>(eventType: TEvents) =>
  (overrideProps: Partial<T> = {}) => {
    const merged = deepmerge(data as Record<string, unknown>, overrideProps);

    const event = {
      ...merged,
      '@type': eventType,
    };

    beam(event);
  };

export default makeEvent;
